import React, { forwardRef } from 'react'
import styled from 'styled-components'
import { useTracking } from '../../hooks/useTracking'
import DetailCard from '../common/detail-card'
import theme from '../../theme'
import { initialRobotStatus, robotStepText } from '../../lib/robot-delivery'

type Props = {}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 10px;
  font-weight: 100;
  font-size: 16px;
  line-height: 21px;
  color: ${theme.midnight800};
`
const Meta = styled.div`
  display: flex;
  gap: 12px;
  font-size: 14px;
  color: ${theme.slate500};
`

/**
 * Replaces the courier card for the indoor leg. Shows where the parcel is
 * (step, floor, ETA) and deliberately nothing about the machine itself — no
 * robot id, model or operator (agreed 2026-09-16).
 */
function RobotInfo(_props: Props, ref: React.Ref<HTMLDivElement>) {
  const { orderDetails, hasWidget, robotStatus } = useTracking()

  if (!orderDetails || !hasWidget) {
    return null
  }

  const status = robotStatus ?? initialRobotStatus(orderDetails.robotDelivery)
  const floor = status?.floor
  const eta = status?.etaMinutes

  return (
    <DetailCard ref={ref} title={'🤖 Robot delivery'} data-testid="robot-info">
      <Content>
        <div data-testid="robot-step">{robotStepText(status)}</div>
        {floor != null || eta != null ? (
          <Meta>
            {floor != null ? <span>Floor {floor}</span> : null}
            {eta != null ? <span>~{eta} min</span> : null}
          </Meta>
        ) : null}
      </Content>
    </DetailCard>
  )
}
export default forwardRef(RobotInfo)
